module.exports = "<div [hidden]=\"!active\" class=\"pane\">\r\n    <ng-content [tabInfo]=\"tabInfo\"></ng-content>\r\n</div>"